exports.baseURL = "https://admin.rigolive.com/";
exports.key = "?SOaT3E25QRvvy=B_|R5XrLxFf)hY+4r";
exports.projectName = "Rigo Live Host"
